import React from 'react';
import { Row } from 'reactstrap';

export const ValidateRemiderToSend = ({ min, max, totalTimeLimitSurvey }) => {
  if (
    min === undefined ||
    max === undefined ||
    totalTimeLimitSurvey === undefined
  )
    return <Row></Row>;
  if (min > max)
    return (
      <Row className="text-danger ml-1">
        {`O tempo de reenvio da pesquisa não pode ultrapassar o limite total da configuração geral. O valor total permitido é: ${totalTimeLimitSurvey} minutos`}
      </Row>
    );
  return <Row></Row>;
};
